import AgreementsAnalysisModule from "./agreementsAnalysisModule";
import AgreementsAnalysisSagas from "./redux/agreementsAnalysisSagas";
import AgreementsAnalysisReducer from "./redux/agreementsAnalysisReducer";

export default {
  Component: AgreementsAnalysisModule,
  moduleName: "agreementsAnalysis",
  saga: AgreementsAnalysisSagas(),
  reducer: AgreementsAnalysisReducer
};
